export default __webpack_public_path__ + "static/media/cypress.c07cf66b.png";